export const SHIPPING_TERMS_FIELDS: string[] = [
  'incoterms',
  'psl',
  'shipment',
  'incotermnamedPlace',
  'ami',
  'po',
  'trailerKey',
  'quoteTerms',
  'transportationGroup',
  'urgency',
] as const;
